import React from "react";
import { useCountry, COUNTRIES } from "@/lib/country-context";

export function CountrySelector() {
  const { country, setCountry, locked } = useCountry();

  // After signup the user is locked to their registered country — render a
  // single static pill so they cannot switch.
  if (locked) {
    return (
      <div
        className="flex items-center gap-2 bg-muted rounded-full px-3 py-1.5 w-fit"
        data-testid="country-selector-locked"
        aria-label={`Country locked to ${country.name}`}
        title={`${country.name} — locked to your registered country`}
      >
        <span className="text-base leading-none">{country.flag}</span>
        <span className="text-xs font-bold text-foreground">{country.currencySymbol}</span>
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">
          {country.code}
        </span>
      </div>
    );
  }

  // Guest / pre-signup: full toggle
  return (
    <div className="flex items-center gap-1 bg-muted rounded-full p-1" data-testid="country-selector">
      {Object.keys(COUNTRIES).map((code) => {
        const c = COUNTRIES[code];
        const active = country.code === code;
        return (
          <button
            key={code}
            onClick={() => setCountry(code)}
            data-testid={`country-${code}`}
            className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold transition-all ${
              active ? "bg-card shadow-sm text-foreground" : "text-muted-foreground hover:text-foreground"
            }`}
            title={c.name}
          >
            <span className="text-sm">{c.flag}</span>
            <span>{c.currencySymbol}</span>
          </button>
        );
      })}
    </div>
  );
}
